export default __webpack_public_path__ + "static/s5-b4784188009df3fd248b4bdc4f791789.jpg";